import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { BonusModel, BonusTypeEnum } from '../../../Models/Game/BonusModel';

export class UIBonusCalculatorController extends AnimationBaseController {
    $model: BonusModel;

    public constructor(@Inject private _options) {
        super('UIBonusCalculatorController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            modelEvents: {
                calculatorBonusChange: (value) => {
                    if (!value) {
                        this.visible = false;
                    }
                }
            },
        };
    }

    protected onInitialize(): void {
        this.visible = true;
        this.gotoAndStop(this.$model.type);
        this.setTextByQuery('text', '');
    }
}
